import { useEffect } from 'react';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('useMessageListener');

export function useMessageListener(callback?: (message: MessageEvent) => void) {
  useEffect(() => {
    const handler = (m: MessageEvent) => {
      const expectedOrigin = Url.origin();
      if (
        m.origin !== expectedOrigin &&
        process.env.NODE_ENV !== 'development'
      ) {
        logger.log('Invalid origin', m.origin);
        return;
      }
      callback && callback(m);
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [callback]);
}
